import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { pluralizeWord } from 'common/utils/pluralizeWord';
import { colorPunch } from 'common/styles/palette';

const DescriptionContainer = styled.p`
    text-align: center;
    margin-bottom: 1rem;
    min-width: 22rem;
`;

const LinkableText = styled.span`
    color: ${({ count }) => (count ? colorPunch : 'black')};
    cursor: ${({ count }) => (count ? 'pointer' : 'unset')};
    font-weight: ${({ count }) => (count ? 'bold' : 'normal')};
`;

const BoldText = styled.span`
    font-weight: bold;
`;

const COMPONENT_NAME = 'FormUsageText';
const EXISTS_ON = ' exists on';
const THEME = 'theme';
const EVENT = 'event';

const FormUsageText = ({ formName, themeCount, eventCount, onClickText, extraInfo }) => (
    <DescriptionContainer>
        <BoldText>{formName}</BoldText> {EXISTS_ON}
        <LinkableText
            data-qa={`${COMPONENT_NAME}__link_text_themes`}
            count={themeCount}
            onClick={themeCount ? onClickText : () => {}}
        >
            {` ${themeCount}`} {pluralizeWord(THEME, themeCount)}
        </LinkableText>{' '}
        and
        <LinkableText
            data-qa={`${COMPONENT_NAME}__link_text_events`}
            count={eventCount}
            onClick={eventCount ? onClickText : () => {}}
        >
            {` ${eventCount}`} {pluralizeWord(EVENT, eventCount)}
        </LinkableText>
        . {extraInfo}
    </DescriptionContainer>
);

FormUsageText.propTypes = {
    formName: PropTypes.string.isRequired,
    themeCount: PropTypes.number.isRequired,
    eventCount: PropTypes.number.isRequired,
    onClickText: PropTypes.func.isRequired,
    extraInfo: PropTypes.string,
};

FormUsageText.defaultProps = {
    extraInfo: '',
};

export default FormUsageText;
